import { RobotInfo, RobotsData } from "./dashboard"
import { Robot } from "../../components/RobotMap/models/Robot";
import { useEffect, useState, useRef } from "react";
import { all } from "axios";
import { DEFAULT_ROBOT_MODEL, isDebugForceDefaultModel, RobotModel } from "../../utils/const";
import { is } from "date-fns/locale";

export const mockRobotTypes = [
  {
    id: "2050E740341332",
    type: "t300",
  },
  {
    id: "2050E740890792",
    type: "cc1",
  },
  {
    id: "2050E740890793",
    type: "flashbot",
  },
  // Swiftie2 treated as a flashbot for now
  // {
  //   id: "F074E41CED02",
  //   type: "flashbot",
  // },
]

// const mockRobotMovements = [
//   {
//     robotId: mockRobotTypes[0].id,
//     movements: [
//       {
//         latitude: 1.2777150168083438,
//         longitude: 103.8349877259443,
//         orientation: 45.41652,
//         waitingTime: 400,
//         duration: 5000,
//       },
//     ]
//   }
// ]

const mockRobotMovements = [
  {
    robotId: "2050E740890793",
    movements: [
      {
        latitude: 1.2777150168083438,
        longitude: 103.8349877259443,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.277368187175,
        longitude: 103.83539296806845,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2777373733989634,
        longitude: 103.83573150798799,
        orientation: 45.41652,
        waitingTime: 4000,
        duration: 5000,
      },
      {
        latitude: 1.2775447348641364,
        longitude: 103.83600781307075,
        orientation: 45.41652,
        waitingTime: 4000,
        duration: 5000,
      },
    ],
  }, {
    robotId: '2050E740341332',
    movements: [
      {
        latitude: 1.2786365652728904,
        longitude: 103.83418308301543,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2783063354091837,
        longitude: 103.83435934228157,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2782386543834292,
        longitude: 103.83373174869689,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2784859632387935,
        longitude: 103.83416487495964,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2791803176560848,
        longitude: 103.83415134520533,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
      {
        latitude: 1.2787294381856782,
        longitude: 103.83366427403581,
        orientation: 45.41652,
        waitingTime: 400,
        duration: 5000,
      },
    ]
  }, {
    robotId: '2050E740890792',
    movements: [
      {
        latitude: 1.2788469515188865,
        longitude: 103.83486490953055,
        orientation: 125,
        waitingTime: 4000,
        duration: 5000,
      },
      {
        latitude: 1.2792279080519648,
        longitude: 103.83481907856793,
        orientation: 125,
        waitingTime: 4000,
        duration: 5000,
      },
      {
        latitude: 1.278816841483419,
        longitude: 103.8347457490637,
        orientation: 125,
        waitingTime: 4000,
        duration: 5000,
      },
      {
        latitude: 1.2788220780004451,
        longitude: 103.83451921327065,
        orientation: 125,
        waitingTime: 4000,
        duration: 5000,
      },
    ]
  }
]
const degToRad = (degrees: number): number => {
  return degrees * (Math.PI / 180);
}

const toDegree = (radians: number): number => {
  return radians * (180 / Math.PI);
}

const calculateRobotOrientation = (start: [number, number], end: [number, number]): number => {
  if (start[0] === end[0] && start[1] === end[1]) {
    return 0; // If the coordinates are the same, return 0  
  }

  // start and end are [longitude, latitude] format
  const fromLatRad = degToRad(start[1]); // latitude
  const toLatRad = degToRad(end[1]); // latitude
  const deltaLngRad = degToRad(end[0] - start[0]); // longitude difference

  const y = Math.sin(deltaLngRad) * Math.cos(toLatRad);
  const x = Math.cos(fromLatRad) * Math.sin(toLatRad) -
    Math.sin(fromLatRad) * Math.cos(toLatRad) * Math.cos(deltaLngRad);

  const bearingRad = Math.atan2(y, x);
  const bearing = (toDegree(bearingRad) + 360) % 360; // Normalize to [0, 360)

  return bearing;
}

const animateRobotMovement = (
  targetPosition: [number, number],
  robot: Robot,
  targetDirection: number,
  duration: number
): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      robot.LatLng = [...targetPosition];
      robot.targetLatLng = [...targetPosition];
      robot.targetDirection = targetDirection;
      resolve()
    }, duration);
  })
  // return new Promise((resolve) => {
  //   if (!robot.LatLng) {
  //     console.error("Robot pose is not defined");
  //     resolve();
  //     return;
  //   }

  //   const startPosition: [number, number] = [...robot.LatLng];
  //   const startTime = Date.now();
  //   let animationId: number;

  //   // Calculate smooth orientation interpolation
  //   const startOrientation = robot.targetDirection || 0;
  //   const endOrientation = calculateRobotOrientation(startPosition, targetPosition);

  //   // Handle orientation wrapping (shortest path)
  //   let orientationDiff = endOrientation - startOrientation;
  //   if (orientationDiff > 180) orientationDiff -= 360;
  //   if (orientationDiff < -180) orientationDiff += 360;

  //   const animate = () => {
  //     const elapsed = Date.now() - startTime;

  //     if (elapsed >= duration) {
  //       // Smoothly set final position
  //       robot.LatLng = [...targetPosition];
  //       robot.targetLatLng = [...targetPosition];
  //       robot.targetDirection = targetDirection;
  //       resolve();
  //       return;
  //     }

  //     // Use easing function for smoother animation
  //     const progress = elapsed / duration;
  //     const easeProgress = easeInOutCubic(progress);

  //     // targetPosition is [longitude, latitude], robot.LatLng is [longitude, latitude]
  //     const currentLng = startPosition[0] + (targetPosition[0] - startPosition[0]) * easeProgress;
  //     const currentLat = startPosition[1] + (targetPosition[1] - startPosition[1]) * easeProgress;
  //     const currentOrientation = startOrientation + orientationDiff;

  //     robot.targetLatLng = [currentLng, currentLat];
  //     robot.targetDirection = ((currentOrientation % 360) + 360) % 360; // Normalize to [0, 360)

  //     animationId = requestAnimationFrame(animate);
  //   };

  //   animationId = requestAnimationFrame(animate);

  //   // Store animation ID for potential cleanup
  //   (robot as any)._animationId = animationId;
  // });
}

// Easing function for smoother animations
const easeInOutCubic = (t: number): number => {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export const useMockRobotMovements = (robots: Robot[]) => {
  const [forceStop, setForceStop] = useState(false);
  const activeAnimations = useRef<Map<string, boolean>>(new Map());
  const timeoutRefs = useRef<Map<string, NodeJS.Timeout>>(new Map());

  const cleanupRobotAnimation = (robotId: string) => {
    // Clear any existing timeout
    const timeout = timeoutRefs.current.get(robotId);
    if (timeout) {
      clearTimeout(timeout);
      timeoutRefs.current.delete(robotId);
    }

    // Mark animation as stopped
    activeAnimations.current.set(robotId, false);

    // Cancel any ongoing animation frame
    const robot = robots.find(r => r.robotId === robotId);
    if (robot && (robot as any)._animationId) {
      cancelAnimationFrame((robot as any)._animationId);
      delete (robot as any)._animationId;
    }
  };

  const runRobotMovement = async (
    robot: Robot,
    duration: number,
    currentStep = 0,
    direction = 'forward' as 'forward' | 'backward'
  ) => {
    const robotMovement = mockRobotMovements.find(rMove => rMove.robotId === robot.robotId);
    if (!robotMovement || forceStop || !activeAnimations.current.get(robot.robotId)) {
      return;
    }

    const movements = robotMovement.movements;
    const currentIndex = currentStep || 0;

    if (!robot.LatLng) {
      console.error("Robot pose is not defined");
      return;
    }

    const nextPosition = movements[currentIndex];

    try {
      // Wait for animation to complete
      await animateRobotMovement(
        [nextPosition.longitude, nextPosition.latitude],
        robot,
        nextPosition.orientation,
        nextPosition.duration
      );

      // Check if we should continue (animation might have been stopped)
      if (!activeAnimations.current.get(robot.robotId) || forceStop) {
        return;
      }

      // Schedule next movement with waiting time
      const timeout = setTimeout(async () => {
        if (!activeAnimations.current.get(robot.robotId) || forceStop) {
          return;
        }

        if (direction === 'forward') {
          if (currentIndex + 1 < movements.length) {
            await runRobotMovement(robot, duration, currentIndex + 1, 'forward');
          } else {
            // Switch to backward movement if there are no more forward movements
            await runRobotMovement(robot, duration, movements.length - 1, 'backward');
          }
        } else {
          // Back to previous position
          if (currentIndex - 1 >= 0) {
            await runRobotMovement(robot, duration, currentIndex - 1, 'backward');
          } else {
            await runRobotMovement(robot, duration, 0, 'forward'); // Restart forward movement
          }
        }
      }, nextPosition.waitingTime || 0);

      timeoutRefs.current.set(robot.robotId, timeout);
    } catch (error) {
      console.error("Animation error:", error);
    }
  };

  useEffect(() => {
    if (robots.length === 0) return;

    const robotIds = robots.map(robot => robot.robotId);
    // Filter robots that have movements defined in mockRobotMovements
    const robotInMocks = mockRobotMovements.filter((rMovement) => robotIds.includes(rMovement.robotId));

    if (robotInMocks.length <= 0) {
      console.warn("No mock movements defined for the provided robots.");
      setForceStop(true);
      return;
    } else {
      setForceStop(false);
    }

    // Start the movement for each robot
    robots.forEach(robot => {
      const robotMovement = mockRobotMovements.find(r => r.robotId === robot.robotId);
      if (robotMovement) {
        activeAnimations.current.set(robot.robotId, true);
        runRobotMovement(robot, 5000); // Start with a duration of 5000ms
      }
    });

    return () => {
      // Cleanup function to stop all movements
      robotIds.forEach(robotId => cleanupRobotAnimation(robotId));
    };
  }, [robots]);

  // Cleanup on forceStop change
  useEffect(() => {
    if (forceStop) {
      robots.forEach(robot => cleanupRobotAnimation(robot.robotId));
    }
  }, [forceStop, robots]);

  return {
    runRobotMovement,
    stopAllAnimations: () => {
      setForceStop(true);
      robots.forEach(robot => cleanupRobotAnimation(robot.robotId));
    }
  };
}

export const getRobotType = (robotId: string) => {
  const findInMocks = mockRobotTypes.find(robot => robot.id === robotId);
  if (findInMocks) {
    return findInMocks.type;
  }
  // This is a placeholder, replace with actual logic to determine robot type
  return "swiftbot";
}

export const getRobotImage = (robotType: string) => {
  if (isDebugForceDefaultModel) {
    return require('../../assets/flashbot.png');
  }
  switch (robotType) {
    case RobotModel.FLASHBOT:
      return require('../../assets/flashbot.png');
    case RobotModel.SWIFTBOT:
      return require('../../assets/swiftbot.png');
    case RobotModel.T300:
      return require('../../assets/robots/t300.png');
    case RobotModel.CC1:
      return require('../../assets/robots/cc1.png');
    case RobotModel.BELLABOT_PRO:
      return require('../../assets/robots/bellabot_pro.png');
    case RobotModel.FLASHBOT_MAX:
      return require('../../assets/robots/flashbot_max.png');
    case RobotModel.PUDUBOT2:
      return require('../../assets/robots/pudubot2.png');
    // Add more cases for other robot types as needed
    default:
      return require('../../assets/swiftbot.png'); // Default to swiftbot if type is unknown
  }
}


export const mockRobots: RobotsData = {
  [mockRobotTypes[0].id]: {
    robotStatus: {
      robot_type: "delivery_robot",
      robot_id: mockRobotTypes[0].id,
      robot_state: "busy",
      battery: 100,
      can_assign_job: true,
      map: "", // Added missing 'map' property
      map_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      layout_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      is_online: true,
      timestamp: 1751367709158,
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_name: "T300",
      robot_serial_number: "R808084220050001",
      display: true,
      pose: {
        latitude: 1.2786365652728904,
        longitude: 103.83418308301543,
        orientation: 45.41652
      }
    },
    jobs: {},
    generalInfo: {
      robot_name: "T300",
      robot_mac: "2050E7403413",
      robot_serial_number: "R808084220050001",
      robot_type: "delivery_robot",
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_model: DEFAULT_ROBOT_MODEL
    }
  } as RobotInfo,
  [mockRobotTypes[1].id]: {
    robotStatus: {
      robot_type: "delivery_robot",
      robot_id: mockRobotTypes[1].id,
      robot_state: "busy",
      battery: 100,
      can_assign_job: true,
      map: "", // Added missing 'map' property
      map_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      layout_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      is_online: true,
      timestamp: 1751367709158,
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_name: "CC1",
      robot_serial_number: "R808084220050001",
      display: true,
      pose: {
        latitude: 1.2790135447507112,
        longitude: 103.83472998909872,
        orientation: 125
      }
    },
    jobs: {},
    generalInfo: {
      robot_name: "CC1",
      robot_mac: "2050E7403413",
      robot_serial_number: "R808084220050001",
      robot_type: "delivery_robot",
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_model: DEFAULT_ROBOT_MODEL
    }
  } as RobotInfo,
  [mockRobotTypes[2].id]: {
    robotStatus: {
      robot_type: "delivery_robot",
      robot_id: mockRobotTypes[2].id,
      robot_state: "busy",
      battery: 100,
      can_assign_job: true,
      map: "", // Added missing 'map' property
      map_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      layout_uuid: "2fef4467-2415-479b-a50f-aace88adc90b",
      is_online: true,
      timestamp: 1751367709158,
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_name: "Flashbot",
      robot_serial_number: "R808084220050001",
      display: true,
      pose: {
        latitude: 1.2777150168083438,
        longitude: 103.8349877259443,
        orientation: 300
      }
    },
    jobs: {},
    generalInfo: {
      robot_name: "Flashbot1",
      robot_mac: "2050E7403413",
      robot_serial_number: "R808084220050001",
      robot_type: "delivery_robot",
      organisation: "07f504c9-07ac-4ec0-8deb-41e9c4118f92",
      robot_model: DEFAULT_ROBOT_MODEL
    }
  } as RobotInfo,
}

export const mockURL = (url: string) => {
  if (process.env.REACT_APP_MOCK_MAP_URL !== 'true') {
    return url
  }
  switch (url) {
    case "https://robohub.io/api/v1/map_images/Maps-L3_1_3sq4oHe.png":
    case "https://robohub.io/api/v1/map_images/sgh.png":
      return "/assets/mock/map_images/Maps-L3_1_3sq4oHe.png"

    case "https://robohub.io/api/v1/map_images/Maps-L11_1_UyKKSsj.png":
      return "/assets/mock/map_images/Maps-L11_1_UyKKSsj.png"

    case "https://robohub.io/api/v1/map_images/Group_1.png":
      return "/assets/mock/map_images/Group_1.png"

    default:
      return url
  }
}